import { Boton, Label, Seccion, Spinner } from 'asocomponents'
import React, { useEffect, useState } from 'react'
import JuicioServices from '../../../../modules/Juicio/application/JuicioServices'
import { useDispatch } from 'react-redux'
import { setIdDenuncia, setIdJuicio } from '../../../redux/observacionSlice'
import { WindowOpener } from '../../../helpers/window-opener'
import { WEBURLEGALES } from '../../../helpers/frontend'
import { formatearFechaLuxon } from '../../../../modules/utils/formatearFecha'
import SiniestrosJuicio from './SiniestrosJuicio'
import { convertirNumero, formatearNumero } from '../../../helpers/funciones'

export default function DatosJuicio({ cargaHabilitada, idJuicio }) {

    const dispatch = useDispatch()

    const [isLoading, setIsLoading] = useState(false)
    const [caratula, setCaratula] = useState("")
    const [siniestros, setSiniestros] = useState([])
    const [estadoJuicio, setEstadoJuicio] = useState("")
    const [fechaNotificacion, setFechaNotificacion] = useState("")
    const [descripcion, setDescripcion] = useState("")
    const [capitalDeman, setCapitalDeman] = useState("")
    const [nroJuicio, setNroJuicio] = useState("")

    const [porcionRecla, setPorcionRecla] = useState("")
    const [jusrisdiccion, setJusrisdiccion] = useState("")
    const [tipo, setTipo] = useState("")
    const [nroExpediente, setNroExpediente] = useState("")
    const [juzgado, setJuzgado] = useState("")
    const [idDenunciaJuicio, setIdDenunciaJuicio] = useState("")
    const [message, setMessage] = useState("")

    const obtenerDatosJuicio = async () => {
        setIsLoading(true)
        const juicioService = new JuicioServices()
        const result = await juicioService.getDatosJuicioByIdReingenieria(idJuicio)

        // const siniestroPrincipal = result.datosSiniestrosJuicio.find(
        //     e => e.principal === true
        // );

        // setIdDenunciaJuicio(siniestroPrincipal?.idDenuncia)
        // setNroSiniestro(siniestroPrincipal?.nroSiniestro)

        setSiniestros(result.datosSiniestrosJuicio)
        setCaratula(result.datosJuicio.caratula)
        setEstadoJuicio(result.datosJuicio.estado)
        setFechaNotificacion(formatearFechaLuxon(result.datosJuicio.fechaNotificacion, "dd/MM/yyyy"))
        setDescripcion(result.datosJuicio.descripcion)
        setCapitalDeman(result.datosJuicio.montoDemanda)
        setPorcionRecla(result.datosJuicio.incapacidadReclamada)
        setJusrisdiccion(result.datosJuicio.jurisdiccion)
        setTipo(result.datosJuicio.tipoProceso)
        setNroExpediente(result.datosJuicio.nroExpediente)
        setJuzgado(result.datosJuicio.juzgado)
        setNroJuicio(idJuicio)
        setIsLoading(false)
    }

    const sonResponse = (err, res) => {
        if (err) {
            setMessage(res)
        } else {
            setMessage(res)
        }
    }


    useEffect(() => {
        if (idJuicio && idJuicio !== -1)
            obtenerDatosJuicio()
    }, [idJuicio])

    useEffect(() => {
        dispatch(setIdJuicio(idJuicio))
        //dispatch(setIdDenuncia(idDenunciaJuicio))
    }, [idDenunciaJuicio])

    if (isLoading) {
        return <Spinner color="red" size="50" />
    }

    return (
        <div>
            {cargaHabilitada &&
                <>
                    <Seccion titulo="INFORMACIÓN" />

                    <div className="w-[98%] mt-4 ml-6">
                        <div className="flex flex-row items-center p-1 text-xs font-bold">
                            <Label texto="Nro Juicio:" /> {nroJuicio}
                        </div>
                    </div>

                    <div className="w-[98%] mt-1 ml-6 grid grid-cols-[max-content_auto] gap-2 items-start">
                        <div className="text-xs font-bold break-words">
                            <Label texto="Carátula:" /> {caratula}
                        </div>

                        <WindowOpener
                            url={`${WEBURLEGALES}/VisorDocDigJuicio/${idJuicio}`}
                            bridge={sonResponse}
                            width={500}
                            height={400}
                        >
                            <Boton
                                fondo="rojo"
                                height="h-8"
                                width="w-10"
                                alt="Documentos Digitalizados Juicio"
                                icono="document"
                            />
                        </WindowOpener>
                    </div>

                    {/* Resto de la información */}
                    <div className="w-[98%] mt-2 ml-6 grid grid-cols-2 gap-x-8 gap-y-2">
                        <div className="flex flex-row items-center p-1 text-xs font-bold">
                            <Label texto="Fecha Notificación:" /> {fechaNotificacion}
                        </div>

                        <div className="flex flex-row items-center p-1 text-xs font-bold">
                            <Label texto="Estado:" /> {estadoJuicio}
                        </div>

                        <div className="flex flex-row items-center p-1 text-xs font-bold">
                            <Label texto="Juzgado:" /> {juzgado}
                        </div>

                        <div className="flex flex-row items-center p-1 text-xs font-bold">
                            <Label texto="Jurisdicción / Tribunal:" /> {jusrisdiccion}
                        </div>

                        <div className="flex flex-row items-center p-1 text-xs font-bold">
                            <Label texto="Monto demandado:" /> $ {formatearNumero(capitalDeman)}
                        </div>

                        <div className="flex flex-row items-center p-1 text-xs font-bold">
                            <Label texto="Expediente:" /> {nroExpediente}
                        </div>

                        <div className="flex flex-row items-center p-1 text-xs font-bold">
                            <Label texto="Porc. Incap. reclamada:" /> {porcionRecla}
                        </div>

                        <div className="flex flex-row items-center p-1 text-xs font-bold">
                            <Label texto="Tipo Proceso:" /> {tipo}
                        </div>

                        <div className="col-span-2 p-1 text-xs font-bold">
                            <SiniestrosJuicio siniestros={siniestros} />
                        </div>
                    </div>
                </>
            }
        </div>
    )
}
